
import { Card } from "@/components/ui/card";
import { useClients } from "@/hooks/useClients";
import { Building2, CircleDot, Briefcase, Users } from "lucide-react";
import { cn } from "@/lib/utils";

export const ClientStats = () => {
  const { data: clients = [] } = useClients();
  
  const stats = [
    {
      title: "Total Clients",
      value: clients.length,
      icon: Building2,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
    },
    {
      title: "Active Clients",
      value: clients.filter(c => c.status === 'active').length,
      icon: CircleDot,
      color: "text-green-500",
      bgColor: "bg-green-50",
    },
    {
      title: "Total Jobs",
      value: "N/A", // Remove jobs count since jobs property doesn't exist
      icon: Briefcase,
      color: "text-purple-500",
      bgColor: "bg-purple-50",
    },
    {
      title: "Client Contacts",
      value: "View All",
      icon: Users,
      color: "text-amber-500",
      bgColor: "bg-amber-50",
      isLink: true
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => (
        <Card key={index} className="border-none shadow-sm">
          <div className="p-4 flex items-center gap-4">
            <div className={cn("w-12 h-12 rounded-full flex items-center justify-center", stat.bgColor)}>
              <stat.icon className={cn("h-6 w-6", stat.color)} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{stat.title}</p>
              <h3 className="text-2xl font-bold">
                {stat.value}
              </h3>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
